export const URUGUAY_LOCALE = "es-UY";
export const URUGUAY_TIME_ZONE = "America/Montevideo";
/** Uruguay no usa horario de verano desde 2015. */
const URUGUAY_UTC_OFFSET = "-03:00";

const DATE_ONLY_RE = /^(\d{4})-(\d{2})-(\d{2})$/;
const UTC_MIDNIGHT_ISO_RE =
  /^(\d{4})-(\d{2})-(\d{2})T00:00:00(?:\.\d{1,3})?Z$/;

const uruguayDateTimeFormatOptions = {
  day: "numeric",
  month: "numeric",
  year: "numeric",
  hour: "2-digit",
  minute: "2-digit",
  hour12: false,
  timeZone: URUGUAY_TIME_ZONE,
};

function parseUruguayCalendarDateTime(year, month, day, hour = 0, minute = 0) {
  const y = String(year);
  const m = String(month).padStart(2, "0");
  const d = String(day).padStart(2, "0");
  const h = String(hour).padStart(2, "0");
  const min = String(minute).padStart(2, "0");
  const date = new Date(`${y}-${m}-${d}T${h}:${min}:00${URUGUAY_UTC_OFFSET}`);
  return Number.isNaN(date.getTime()) ? null : date;
}

/**
 * @param {unknown} article
 * @returns {string | number | null}
 */
export function getUploadArticleRecordTimestamp(article) {
  if (!article || typeof article !== "object") {
    return null;
  }
  return (
    article.timestamp ??
    article.created_at ??
    article.createdAt ??
    null
  );
}

/**
 * @param {string | number | Date | null | undefined} value
 * @returns {Date | null}
 */
export function parseUploadArticleTimestamp(value) {
  if (value == null || value === "") {
    return null;
  }

  if (value instanceof Date) {
    return Number.isNaN(value.getTime()) ? null : value;
  }

  if (typeof value === "number") {
    const date = new Date(value);
    return Number.isNaN(date.getTime()) ? null : date;
  }

  const str = String(value).trim();
  if (!str) {
    return null;
  }

  const dateOnlyMatch = DATE_ONLY_RE.exec(str);
  if (dateOnlyMatch) {
    const [, year, month, day] = dateOnlyMatch;
    return parseUruguayCalendarDateTime(year, month, day);
  }

  const utcMidnightMatch = UTC_MIDNIGHT_ISO_RE.exec(str);
  if (utcMidnightMatch) {
    const [, year, month, day] = utcMidnightMatch;
    return parseUruguayCalendarDateTime(year, month, day);
  }

  if (/^\d+$/.test(str)) {
    const numeric = Number(str);
    const date = new Date(str.length <= 10 ? numeric * 1000 : numeric);
    return Number.isNaN(date.getTime()) ? null : date;
  }

  const date = new Date(str);
  return Number.isNaN(date.getTime()) ? null : date;
}

/**
 * Formato d/m/y h:i según calendario y huso horario de Uruguay (es-UY).
 * @param {string | number | Date | null | undefined} value
 * @returns {string | null}
 */
export function formatUploadArticleDateTime(value) {
  const date = parseUploadArticleTimestamp(value);
  if (!date) {
    return null;
  }

  return date.toLocaleString(URUGUAY_LOCALE, uruguayDateTimeFormatOptions);
}
